export default __webpack_public_path__ + "static/media/216.696affe5.gif";